import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const midday = createTheme({
  ...templateThemeTokens,
  colors: {
    cardGradient1: 'rgba(255, 255, 255, 0.21)',
    cardGradient2: 'rgba(255, 255, 255, 0.07)',
    defaultFont: '$brandBlack',
    inverseDefaultFont: '$white',
    pageBackground: '$white',
    primaryGradient1: '#8F6FDB',
    primaryGradient2: '#FF9E31',
    underlineEmphasis: '#DDD8C5',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.losAngeles.midday.accent
      ? THEME_DEFAULT_FONTS.losAngeles.midday.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.losAngeles.midday.body.value,
    heading: THEME_DEFAULT_FONTS.losAngeles.midday.headline.value,
  },
});
